import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";

// styles
import styles from "./styles";

class InlineCode extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
  };

  render() {
    const { children, classes } = this.props;

    return <span className={classes.inlineCode}>{children}</span>;
  }
}

export default withStyles(styles)(InlineCode);
